<div class="container">
  <h3 class="title">{{ title }}</h3>
  @for (missingInfo of missingRequiredFields; track missingInfo) {
    <div>
      <h4 class="item">{{ missingInfo.item }}</h4>
      @for (missingSection of missingInfo.sections; track missingSection) {
        <div
          class="section-container"
          >
          <p class="section">{{ missingSection.section }}</p>
          @for (field of missingSection.fields; track field) {
            <div>
              <p class="field">{{ field }}</p>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
